import { MutableRefObject, useEffect, useRef } from 'react'

import useOnScreen from './useOnScreen'

export const useDwellTime = ({
  elementRef,
  onDwellStart,
  onDwellEnd
}: {
  elementRef: MutableRefObject<Element | null>
  onDwellStart: (totalDwellTime: number) => void
  onDwellEnd: (totalDwellTime: number) => void
}) => {
  const dwellTime = useRef<number>(0)
  const lastViewStart = useRef<number>()
  const isVisible = useOnScreen(elementRef)

  useEffect(() => {
    if (isVisible) {
      lastViewStart.current = Date.now()
      onDwellStart(dwellTime.current)
    } else if (lastViewStart.current) {
      dwellTime.current += Date.now() - lastViewStart.current
      lastViewStart.current = undefined
      onDwellEnd(dwellTime.current)
    }
  }, [onDwellStart, onDwellEnd, isVisible])
}

export default useDwellTime
